(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-page"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var videos = document.querySelectorAll('.js-autoplay-video');
    if (!videos.length || !('IntersectionObserver' in window)) return;
    videos.forEach(function(v) {
      var userPaused = false;
      v.addEventListener('pause', function() {
        if (!v.ended && v.currentTime > 0 && v.readyState > 2) {
          userPaused = true;
        }
      });
      v.addEventListener('play', function() { userPaused = false; });
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            if (!userPaused) {
              var p = v.play();
              if (p && p.catch) p.catch(function(){});
            }
          } else {
            if (!v.paused) v.pause();
          }
        });
      }, { threshold: 0.4 });
      io.observe(v);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var honeypot = document.getElementById('contact-url');
    if (!honeypot) return;
    var form = honeypot.closest('form');
    if (!form) return;
    var errorEl = document.getElementById('recaptcha-error');

    form.addEventListener('submit', function(e) {
      // Honeypot check
      if (honeypot.value !== '') {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      // reCAPTCHA check
      if (typeof grecaptcha !== 'undefined') {
        var response = grecaptcha.getResponse();
        if (!response || response.length === 0) {
          e.preventDefault();
          e.stopPropagation();
          if (errorEl) errorEl.style.display = 'block';
          return false;
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  var toggle = document.getElementById('menu-toggle');
  var nav = document.getElementById('main-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function() {
      nav.classList.toggle('active');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  var carousel = document.getElementById('reviews-carousel');
  var prev = document.getElementById('reviews-prev');
  var next = document.getElementById('reviews-next');
  if (carousel && prev && next) {
    var card = carousel.querySelector('.review-item');
    var scrollAmount = card ? card.offsetWidth + 20 : 280;
    prev.addEventListener('click', function() {
      carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    next.addEventListener('click', function() {
      carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
